import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const SettingsContext = createContext();

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error('useSettings must be used within SettingsProvider');
  }
  return context;
};

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    site_name: 'أمازول',
    site_description: 'منصة التجارة الإلكترونية الرائدة في السودان',
    contact_email: 'info@amazol.sd',
    contact_phone: '+249123456789',
    contact_address: 'الخرطوم، السودان',
    social_facebook: 'https://facebook.com/amazolsudan',
    social_instagram: 'https://instagram.com/amazolsudan',
    social_twitter: 'https://x.com/amazolsudan',
    currency: 'SDG',
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await api.get('/settings/public');
      setSettings(response.data.data);
    } catch (error) {
      console.error('Error fetching settings:', error);
      // Keep default values if fetch fails
    } finally {
      setLoading(false);
    }
  };

  return (
    <SettingsContext.Provider value={{ settings, loading, refetch: fetchSettings }}>
      {children}
    </SettingsContext.Provider>
  );
};
